import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export default function OffboardConfirmDialog({
  open,
  onOpenChange,
  employeeName,
  onConfirm,
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="offboard-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display">
            Offboard {employeeName}?
          </AlertDialogTitle>
          <AlertDialogDescription>
            This removes them from the directory. Their tasks will be unassigned;
            leave history is kept for audit. This cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="border-[#e5e5e0]">Cancel</AlertDialogCancel>
          <AlertDialogAction
            data-testid="offboard-confirm-btn"
            onClick={onConfirm}
            className="bg-[#d34949] text-white hover:bg-[#b93b3b]"
          >
            Offboard
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
